<template>
  <div class="page-container md-layout-column">

    <md-dialog-alert
      :md-active.sync="error.show"
      :md-title="error.title"
      :md-content="errorMessage(error.error)"
      md-confirm-text="Ok"/>

    <div v-if="order && order.order">

      <md-content v-if="order.order.WorkStatusId === 1 || order.order.WorkStatusId === 2">

        <md-field>
          <label for="status">Выберите статус</label>
          <md-select v-model="selectStatusID" name="status" id="status">
            <md-option value="3">Полностью выполнен</md-option>
            <md-option value="4"
                       v-if="order.order.ForChoice === 1 && order.order.NotOpen === 0 && order.items.length > 1">
              Частично выполнен
            </md-option>
            <md-option value="5">Отказ</md-option>
            <md-option value="6">Перенос</md-option>
          </md-select>
        </md-field>

        <md-field>
          <label>{{searchFieldName(order.searchField)}}</label>
          <md-input :value="viewOrderNumber" readonly/>
        </md-field>

        <md-button class="md-raised md-primary" v-on:click="cancel">Назад</md-button>

        <app-done v-if="selectStatusID==='3'" v-bind:order="order"/>
        <app-done-part v-if="selectStatusID==='4'" v-bind:order="order"/>
        <app-denied v-if="selectStatusID==='5'" v-bind:order="order"/>
        <app-transfer v-if="selectStatusID==='6'" v-bind:order="order"/>
      </md-content>

      <md-content v-if="!(order.order.WorkStatusId === 1 || order.order.WorkStatusId === 2)">
        <p class="md-headline">
          По заказу №{{order.order.Id}} Установлен финальный статус {{nameWorkStatus(order.order.WorkStatusId)}}
        </p>
        <md-button class="md-raised md-primary" v-on:click="cancel">Поиск</md-button>
      </md-content>
    </div>

    <div v-if="!(order && order.order)">
      <span class="md-title">Загрузка...</span>
      <md-progress-bar md-mode="query"/>
    </div>
  </div>
</template>

<script>

  import Done from './Done';
  import DonePart from './DonePart';
  import Denied from './Denied';
  import Transfer from './Transfer';

  export default {
    name: "SelectFinalStatus",
    data() {
      return {
        selectStatusID: -1,
        statusOptions: {},
        viewOrderNumber: '', // курьер должен видеть то поле которое ввел
      }
    },
    methods: {
      searchFieldName(fieldType) {
        if (fieldType === 'ID') return 'Номер заказа в ТД';
        if (fieldType === 'BarCode') return 'Бар-код';
        if (fieldType === 'WebShopNumber') return ' Номера заказа ИМ';
      },
      nameWorkStatus(workStatusID) {
        if (workStatusID === 3) return '"Полностью выполнен"';
        if (workStatusID === 4) return '"Частично выполнен"';
        if (workStatusID === 5) return '"Отказ"';
      },
      errorMessage(error) {
        return this.$store.getters.getErrorMessage(error)
      },
      cancel: function () {
        this.$router.push("/search");
      }
    },
    computed: {
      error() {
        let err = this.$store.getters.getErrorByMethod('getOrder');
        if (err.show) {
          // на странице может произойти только 1 ошибка, это если заказ не был найдет, тогда редиректим на поиск
          this.$router.push({path: '/search'});
        }
        return err;
      },
      order() {
        let order = this.$store.getters.getOrder;

        if (order.order && order.order.Id === Number(this.$route.params.id)) {

          if (order.searchField === 'ID') this.viewOrderNumber = order.order.Id;
          if (order.searchField === 'WebShopNumber') this.viewOrderNumber = order.order.WebshopNumber;
          if (order.searchField === 'BarCode') this.viewOrderNumber = order.order.BarCode;

          if (this.viewOrderNumber === '') {
            order.searchField = 'ID';
            this.viewOrderNumber = order.order.Id;
          }

          return order
        } else {
          // если заказ не тот или его нет то ищем
          if (this.$store.getters.getWSConnectState.connect) {
            this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
              event: "getOrderByID",
              data: this.$route.params.id,
            }));
          }
        }
      }
    },
    components: {
      AppDone: Done,
      AppDonePart: DonePart,
      AppDenied: Denied,
      AppTransfer: Transfer,
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Status/SelectFinalStatus.vue